import { useAuth } from '@/auth/hyper-auth'
import axios from 'axios'

const overrideConfig = {
    baseURL: process.env.VUE_APP_COMMON_URL,
    namespace: process.env.VUE_APP_NAMESPACE,
    serviceGroup: process.env.VUE_APP_SERVICE
}
const service = {
    getDocumentVersions ({ locale, type }) {
        const { auth } = useAuth(overrideConfig)
        return auth.axiosIns.get(`/v1/hyper-common/auth/docs/${locale}/${type}`)
    },
    getDocumentContent ({ locale, type, version }) {
        return axios.get(`${process.env.VUE_APP_HYPER_V3_CONTENT}/docs/${process.env.VUE_APP_NAMESPACE}/${locale}/${type}/${version}.json`)
    },

    /* agreement */
    getAgreementDocumentVersions (locale) {
        return this.getDocumentVersions({ locale, type: 'agreement' })
    },
    getAgreementDocumentContent (version, locale) {
        return this.getDocumentContent({ locale, version, type: 'agreement' })
    },

    /* privacy - with locale */
    getPrivacyDocumentVersions (locale = 'ko') {
        return this.getDocumentVersions({ locale, type: 'privacy' })
    },
    getPrivacyDocumentContent (version, locale) {
        return this.getDocumentContent({ locale, version, type: 'privacy' })
    }
}

export {
    service,
    overrideConfig,
    useAuth
}
